// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607302220/js/" + chunkId + "." + {"44":"e8f57dd3","225":"b6b2f89a","481":"4dc369d6","486":"47dfef2d","770":"27a4ae91"}[chunkId] + ".0.07595245183038002.chunk.js";
};